import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';
import { withRouteData, withSiteData } from 'react-static';

import BrandButton from '../brand/BrandButton';
import { Section } from './shared';
import { media } from '../../styles/style-utils';
import { GIFT_CARD_PATH } from '../../constants';
import downloadIcon from '../../assets/images/home/icon-download.svg';

const Wrapper = styled(Section)`
  padding-top: 28px;
  padding-bottom: 28px;
  background-color: var(--b-white);
`;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px;

  ${media.large`
    grid-template-columns: repeat(4, minmax(0, 1fr));
  `};

  > a,
  > div {
    height: 76px;
    width: 100%;
    min-width: 0;
  }
`;

const linkWithHover = color => styled(BrandButton)`
  &:hover {
    background-color: ${color};
  }
`;

const TryPremium = linkWithHover('var(--b-lilac)');
const Gift = linkWithHover('var(--b-pink)');
const Help = linkWithHover('var(--b-light-blue)');

const Download = styled(BrandButton)`
  gap: 4px;
  padding: 0;
  background-color: transparent;

  &:hover {
    background-color: transparent;
  }

  .label,
  .icon {
    height: 100%;
    background-color: var(--b-silver);
    transition: background-color 0.16s ease;
  }

  .label {
    display: flex;
    flex: 1 1 auto;
    align-items: center;
    justify-content: center;
    min-width: 0;
    padding: 0 31px;
    border-radius: 100px;
  }

  .icon {
    display: none;
    flex: 0 0 73px;
    height: 73px;
    border-radius: 50%;
    background-image: url(${downloadIcon});
    background-position: center;
    background-size: 48px 48px;
    background-repeat: no-repeat;

    ${media.large`
      display: block;
    `};
  }

  &:hover .label,
  &:hover .icon {
    background-color: var(--c-yellow);
  }
`;

const QuickLinks = ({ appDomain, language }) => (
  <Wrapper>
    <Row>
      <TryPremium
        to={`${appDomain}/discover?showPreviewsModal=1`}
        openInNewTab
        tone="silver"
        size="large"
        trackingData={{ title: 'Try Premium for Free', from: 'Home Quick Links' }}
      >
        <FormattedMessage id="home.links.try-premium" defaultMessage="Try Premium for Free" />
      </TryPremium>
      <Download
        to={`${appDomain}/download`}
        openInNewTab
        tone="silver"
        size="large"
        trackingData={{ title: 'Download', from: 'Home Quick Links' }}
      >
        <span className="label">
          <FormattedMessage id="header.cta.download-short" defaultMessage="Download" />
        </span>
        <span className="icon" aria-hidden="true" />
      </Download>
      <Gift
        to={`/${GIFT_CARD_PATH}`}
        tone="silver"
        size="large"
        trackingData={{ title: 'Gift IDAGIO', from: 'Home Quick Links' }}
      >
        <FormattedMessage id="home.links.gift" defaultMessage="Gift IDAGIO" />
      </Gift>
      <Help
        to={`https://support.idagio.com/${language}`}
        openInNewTab
        tone="silver"
        size="large"
        pill
        trackingData={{ title: 'Help Centre', from: 'Home Quick Links' }}
      >
        <FormattedMessage id="home.links.help" defaultMessage="Help Centre" />
      </Help>
    </Row>
  </Wrapper>
);

QuickLinks.propTypes = {
  appDomain: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
};

export default withSiteData(withRouteData(QuickLinks));



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/home/QuickLinks.js